import React from 'react';
import {
  Wrench,
  PeopleGroup,
  Handshake,
  LightBulb,
  BookInfo,
  Presentation,
} from '@procore/core-icons';

export const ADDITIONAL_CATEGORY_LINKS = [
  {
    href: '/',
    title: 'additionalCategoryLinks.spotlight.title',
    slug: '/',
    subtitle: 'additionalCategoryLinks.spotlight.subtitle',
    showTitleSection: true,
  },
  {
    href: '/listings/built-by',
    title: 'additionalCategoryLinks.builtBy.title',
    slug: 'built-by',
    subtitle: 'additionalCategoryLinks.builtBy.subtitle',
    showTitleSection: true,
  },
  {
    href: '/featured/new',
    title: 'additionalCategoryLinks.new.title',
    slug: 'new',
    subtitle: 'additionalCategoryLinks.new.subtitle',
    showTitleSection: true,
  },
  {
    href: '/listings',
    title: 'additionalCategoryLinks.allApps.title',
    slug: 'listings',
    showTitleSection: false,
  },
];

export const COMPONENT_MAP = {
  iframe: 'Embedded',
  fullscreen: 'Embedded',
  sidepanel: 'Embedded',
};

export const NAVIGATION_MENU_ITEMS = [
  {
    icon: <Wrench size="lg" />,
    label: 'navbar.app',
    href: 'https://developers.procore.com/documentation/partner-overview',
    testid: 'build-app',
    disabled: window.IS_FEDRAMP,
  },
  {
    icon: <PeopleGroup size="lg" />,
    label: 'navbar.community',
    href: 'https://community.procore.com/s/?utm_source=header&utm_medium=link&utm_campaign=Community%20Header&utm_id=community',
    testid: 'community',
  },
  {
    icon: <Handshake size="lg" />,
    label: 'navbar.partner',
    href: 'https://developers.procore.com/partner',
    testid: 'partner',
    disabled: window.IS_FEDRAMP,
  },
  {
    icon: <LightBulb size="lg" />,
    label: 'navbar.idea',
    href: 'https://feedback.procore.com/forums/183340-customer-feedback-for-procore-technologies-inc?category_id=78299',
    testid: 'idea',
  },
  {
    icon: <Presentation size="lg" />,
    label: 'navbar.webinars',
    href: 'https://www.procore.com/virtual-training?groups=integration-spotlights',
    testid: 'webinars',
  },
  {
    icon: <BookInfo size="lg" />,
    label: 'navbar.faq',
    href: '/faqs',
    testid: 'faq',
  },
];

export const PARTNER_LINK = 'https://developers.procore.com/partner';
export const DOCS_LINK =
  'https://developers.procore.com/documentation/introduction';
